export function societyReducer(state = {},
{
    type,
    payload
}){
    
    switch(type){
        
        case "NEW_SOCIETY":     
        case "UPDATE_SOCIETY":     
        case "GET_SOCIETY":

            return payload

        default:
            return state;
    }
    
}